export default __webpack_public_path__ + "static/ThinkstockPhotos-486707220_article-cadfa1fa6d4681ff0e35e614fca7338d.jpg";